/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RefundRequestDialog.vue?vue&type=template&id=97d0c0e4"
import script from "./RefundRequestDialog.vue?vue&type=script&lang=js"
export * from "./RefundRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d0c0e4')) {
      api.createRecord('97d0c0e4', component.options)
    } else {
      api.reload('97d0c0e4', component.options)
    }
    module.hot.accept("./RefundRequestDialog.vue?vue&type=template&id=97d0c0e4", function () {
      api.rerender('97d0c0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/RefundRequestDialog.vue"
export default component.exports